import { useSelector } from 'react-redux';

// Whether the signed-in user is on a call they fielded or an intercom call they connected — the same
// rule as `onCall` in useNotificationAction. Nothing that reloads the tab may run while this is true.
export const useOnCall = () => {
    const uid = useSelector(state => state.user.userData?.uid);
    const activeCalls = useSelector(state => state.calls?.active);
    const activeComs = useSelector(state => state.coms?.active);

    if (!uid) return false;

    return (
        Boolean(activeCalls?.some(call => call.fielded_by === uid)) ||
        Boolean(activeComs?.some(call => call.connected_by === uid))
    );
};
